// extracted by mini-css-extract-plugin
export default {"table":"ChooseYear_table__nfAqx","tableItem":"ChooseYear_tableItem__BKWQy"};